module.exports = __webpack_public_path__ + "static/media/avatar.3ce10aa5.jpg";